import webBiLogger from '@wix/web-bi-logger';

export const createBiLogger = () =>
  webBiLogger
    .factory()
    .updateDefaults({
      _artifact_name: 'com.wixpress.users.login-react-app',
    })
    .logger();
